<script setup lang="ts">
import { useCourseStore } from '../stores/courseStore';
import type { CourseCategory } from '../types/course';
import { useSwipe } from '@vueuse/core';
import { ref, computed } from 'vue';

const store = useCourseStore();
const el = ref<HTMLElement | null>(null);

const categories: { id: CourseCategory; label: string }[] = [
  { id: 'asanas', label: 'Asanas' },
  { id: 'meditation', label: 'Meditation' },
  { id: 'other offerings', label: 'Sonstige Angebote' },
  { id: 'my day', label: 'Mein Tag' },
];

const selectedCoursesCount = computed(() => {
  return store.getSelectedCoursesCount();
});

useSwipe(el, {
  onSwipeStart: (e) => {
    e.preventDefault();
  },
  onSwipe: (e) => {
    e.preventDefault();
  },
  onSwipeEnd: (e, direction) => {
    const currentIndex = categories.findIndex(
      (c) => c.id === store.selectedCategory
    );
    if (direction === 'left' && currentIndex < categories.length - 1) {
      store.selectedCategory = categories[currentIndex + 1].id;
    } else if (direction === 'right' && currentIndex > 0) {
      store.selectedCategory = categories[currentIndex - 1].id;
    }
  },
});
</script>

<template>
  <div ref="el" class="category-tabs">
    <button
      v-for="category in categories"
      :key="category.id"
      :class="{ active: store.selectedCategory === category.id }"
      @click="store.selectedCategory = category.id"
    >
      {{ category.label }}
      <span v-if="category.id === 'my day' && selectedCoursesCount > 0" class="counter">
        {{ selectedCoursesCount }}
      </span>
    </button>
  </div>
</template>

<style scoped>
.category-tabs {
  display: flex;
  justify-content: space-around;
  background: #960040;
  padding: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  touch-action: none;
}

button {
  background: none;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  cursor: pointer;
  opacity: 0.7;
  white-space: nowrap;
  position: relative;
}

button.active {
  opacity: 1;
  border-bottom: 2px solid white;
}

.counter {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ffd21f;
  color: #960040;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}
</style>